export default "__VITE_ASSET__CHXHnMrx__"